export default __webpack_public_path__ + "static/normal_curve-df03b7b860290fd0e02752adb9ace3a0.png";